/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : appTheme.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

const appTheme = {
  primaryColor: "black",
  secondaryColor: "#26890d",
  buttonTextSize: ".8rem",
  textSize: "18px",
  textHeadingSize: "20px",
  fontSizeSmall: ".8rem",
  fontSizeMedium: ".9rem",
  fontSizeLarge: "1rem",
  fontSizexl: "1.2rem",
  fontSizexs: ".7rem",
};

export default appTheme;
